import React from "react";
import { Stack } from "@shopify/polaris";
import { useTranslation } from "react-i18next";
import {
  AnalyticsMinor,
  ThemeEditMajor,
  SearchMinor,
  LanguageMinor,
} from "@shopify/polaris-icons";
import FeatureItem from "./FeatureItem";

export default function EnabledFeatureList({
  enabledFeatures,
  spacing,
  showDescriptions,
}) {
  const { t } = useTranslation();
  
  const featureList = {
    analytics: {
      title: t("settings.plan.features.analytics.title"),
      description: t("settings.plan.features.analytics.description"),
      icon: AnalyticsMinor,
    },
    internationalization: {
      title: t("settings.plan.features.internationalization.title"),
      description: t("settings.plan.features.internationalization.description"),
      icon: LanguageMinor,
    },
    custom_themes: [
      {
        title: t("settings.plan.features.customThemes.editLiquid.title"),
        description: t("settings.plan.features.customThemes.editLiquid.description"),
        icon: ThemeEditMajor,
      },
      {
        title: t("settings.plan.features.customThemes.editStructuredData.title"),
        description: t("settings.plan.features.customThemes.editStructuredData.description"),
        icon: SearchMinor,
      },
    ],
  };
  if (!enabledFeatures) return null;
  const featuresToShow = enabledFeatures
    .map((featureKey) => featureList[featureKey])
    .flat()
    .filter((feature) => feature);

  return (
    <Stack vertical spacing={spacing}>
      {featuresToShow.map((feature) => (
        <Stack.Item key={feature.title}>
          <FeatureItem
            icon={feature.icon}
            title={feature.title}
            description={showDescriptions !== false && feature.description}
          />
        </Stack.Item>
      ))}
    </Stack>
  );
}
